import { useCallback } from 'react';

export const formatCedula = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 10);
    const part3 = digits.slice(10, 11);

    let formatted = part1;
    if (part2) formatted += '-' + part2;
    if (part3) formatted += '-' + part3;

    return formatted;
};

export const useFormatCedula = () => {
    const onChangeHandler = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>, onChange?: (value: string) => void) => {
            const formatted = formatCedula(e.target.value);
            e.target.value = formatted;
            if (onChange) onChange(formatted);
        },
        []
    );

    return {
        formatCedula,
        onChangeHandler
    };
};